import React from 'react';
import { Chip } from '@material-ui/core';

import { getGradingColors } from 'lib/gradingColors';

const ScoreField = ({ value }) => {
  const color = getGradingColors(value);
  return value ? (
    <Chip
      style={{ color: color.typography, backgroundColor: color.background }}
      label={value}
    />
  ) : null;
};

export default ScoreField;
